import { CSSObject } from "@emotion/react";

import { gradientColors } from "@/components/AIComponents/AiComponents.style";

export const backgroundLinearGradient = `linear-gradient(
  to bottom right,
  ${gradientColors.position0},
  ${gradientColors.position25},
  ${gradientColors.position50},
  ${gradientColors.position100}
)`;

export const modalRootCss: CSSObject = {
  zIndex: 99,
};

export const modalContentWrapperCss = (isStudent: boolean): CSSObject => ({
  "&&": {
    maxWidth: isStudent ? "1342px" : "1244px",
    maxHeight: "800px",
    border: "2px solid transparent",
    borderImage: `${backgroundLinearGradient} 1`,
  },
});

export const scrollableBodyCss: CSSObject = {
  "&&": {
    padding: "0",
    flex: 1,
  },
};

export const titleIconCss: CSSObject = {
  marginRight: "8px",
  width: "24px",
  verticalAlign: "bottom",
  fill: "transparent",
  path: {
    stroke: "currentColor",
  },
};
